export const rgba = (r,g,b,a) => (`rgba(${r}, ${g}, ${b}, ${a})`);
export const rgb = (r,g,b) => (`rgb(${r}, ${g}, ${b})`);

export function fadeRGB(r1, g1, b1, r2, g2, b2, transitionAmount){
  const r = r1 + (r2-r1)*transitionAmount;
  const g = g1 + (g2-g1)*transitionAmount;
  const b = b1 + (b2-b1)*transitionAmount;
  return [r, g, b]
}
